import { AxiosMax } from "./Axios";
import { retry, requestReplayWithNewIdToken } from "./axiosRetry";
import { getConfig, urlResolve } from "./utils";
import { checkErrorStatus } from "./checkErrorStatus";
import { generateNewParams } from "@/utils";
import { getGateWayToken } from "@/services";
import Vue from "vue";
import store from "@/store";

// 请求拦截数组
const requestInterceptorsArray = [
  // 请求地址
  async function (config) {
    // console.error('处理 baseURL 拦截器2')
    const gatewayKey = config.gatewayKey;
    const baseURL = `${await getConfig(gatewayKey)}`;
    config.url = urlResolve(baseURL, config.url);
    return config;
  },
  // 认证
  async function (config) {
    // TODO token的事儿
    if (config.needGateWayToken) {
      let authorization = "";
      const regex = /slbrowser_pc_ai_assist_authorization=([^;]*)/;
      const match = document.cookie.match(regex);
      authorization = match ? match[1] : null;
      // console.log('auth授权信息获取 document.cookie',authorization)
      // authorization = document.cookie.replace(
      //  /(?:(?:^|.*;\s*)slbrowser_mobile_ai_assist_authorization\s*\=\s*([^;]*).*$)|^.*$/,
      //  "$1")
      // debugger
      // console.error('授权 document.cookie',authorization)
      if (!authorization) {
        console.log("c重新获取auth授权信息获取 document.cookie", authorization);
        // debugger
        authorization = await getGateWayToken();
      }
      // console.error('axios统一封装里面获取gateWayToken',gateWayToken)
      config.headers["Authorization"] = `${authorization}`;
    }
    return config;
  },
  // 追加签名,并处理入参
  async function (config) {
    // 是否需要签名
    if (config.needSign) {
      if (config.method.toLowerCase() === "get") {
        // GET 请求，将签名参数追加到 URL 的查询参数中
        config.params = generateNewParams({
          ...config.params,
        });
      } else if (config.method.toLowerCase() === "post") {
        // 是否是formData 格式入参
        if (config.data instanceof FormData) {
          // 获取 config.data 中的所有参数
          let params = {};
          for (let [key, value] of config.data.entries()) {
            if (key !== "file") {
              // 排除 file 参数
              params[key] = value;
            }
          }
          params = generateNewParams(params);
          for (const key in params) {
            // eslint-disable-next-line no-prototype-builtins
            if (params.hasOwnProperty(key)) {
              config.data.set(key, params[key]); // 更新这个键的值
            }
          }
        } else {
          config.data = generateNewParams({
            ...config.data,
          });
        }
      }
    }
    return config;
  },
  // 处理headers和toast
  async function (config) {
    config.headers = {
      "Content-Type":
        config.data instanceof FormData
          ? "multipart/form-data"
          : "application/json",
      ...config.headers,
    };
    if (config?.toast === undefined) {
      config.toast = false;
    }
    return config;
  },
];
// 响应错误拦截器 gatewayResponseErrorHandler
const gatewayResponseErrorHandler = function (error, axiosInstance) {
  // 请求没有被发送出去
  if (!error.request) {
    //TODO sentry 上报错误 到监控平台
    return Promise.reject(error);
  }
  const { replay = false } = error.config;
  // error 断网
  if (error.code === "ERR_NETWORK") {
    store.commit("setNetworkError", true);
    Vue.prototype.$message({
      message: "您当前处于断网环境，请联网后重试",
      duration: 2000,
    });
    return Promise.reject(error);
  }

  // error 请求已经被发送出去，但是没有收到服务器的响应
  if (!error.response) {
    // error 请求超时
    if (error.code === "ECONNABORTED") {
      console.warn("请求超时", error);
      Vue.prototype.$message({
        message: "请求超时",
        duration: 2000,
      });
    }
    return Promise.reject(error);
  }
  // 服务器 返回
  const { response, message } = error;
  checkErrorStatus(
    response ? response.status : undefined,
    message,
    (message) => {
      Vue.prototype.$message({
        message,
        duration: 2000,
      });
    }
  );
  if (response.status === 401) {
    if (!replay) {
      return requestReplayWithNewIdToken(axiosInstance, error);
    } else {
      Vue.prototype.$message({
        message: "登录已过期，请重新登录",
        duration: 2000,
      });
    }
  } else {
    return retry(axiosInstance, error);
  }
};
// 响应正常拦截器 gatewayResponseHandler

/**
 * @description 网关响应数据处理，该处处理http status 200 但是业务异常的情况
 * @param response
 * @returns
 */
const gatewayResponseHandler = (response) => {
  let { code, message = "" } = response.data;
  // 能量值不够业务码
  if (code !== 10000 && response.config.needToast) {
    Vue.prototype.$message({
      message: message || "服务异常",
      duration: 2000,
    });
  }
  return response.data;
};

const _RequstInterceptors = {
  requestInterceptors: requestInterceptorsArray,
  requestInterceptorsCatch: function (err) {
    return err;
  },
  responseInterceptor: gatewayResponseHandler,
  responseInterceptorsCatch: gatewayResponseErrorHandler,
};

export const axiosGateway = new AxiosMax({
  directlyGetData: false,
  needGateWayToken: false,
  needCommonPayloadParams: true, // 需要追加统一共用参数
  needSign: false, // 需要签名
  timeout: 1000 * 20,
  interceptors: _RequstInterceptors,
  abortRepetitiveRequest: false,
  retryConfig: {
    count: 0,
    waitTime: 500,
  },
});
